import { useQuery } from "@tanstack/react-query";
import { updatePassword } from "../services/http-service/updatepassword";

export const useUpdatePassword = ({ updatedPasswordData, enabled }: { updatedPasswordData: any; enabled: boolean }) => {
  const {
    isLoading: updatedPasswordLoading,
    isError: errorUpdatedPassword,
    refetch: RefetchUpdatedPassword,
    data: updatedPasswordResponse,
  } = useQuery({
    queryKey: ["updatePassword"],
    queryFn: async () => {
      await updatePassword({ ...updatedPasswordData });
    },
    refetchInterval: false,
    refetchIntervalInBackground: false,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });

  return { updatedPasswordLoading, errorUpdatedPassword, RefetchUpdatedPassword, updatedPasswordResponse };
};
